
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M110.13 9.69A6.41 6.41 0 00105.77 8h-32a10.18 10.18 0 00-2.48-4.86A9.94 9.94 0 0063.94 0a9.9 9.9 0 00-9.88 8H22a6 6 0 00-6 6v108a6 6 0 006 6h84a5.94 5.94 0 006-6V14a5.85 5.85 0 00-1.87-4.31zM55.86 12a2 2 0 002-2 5.91 5.91 0 016.08-6 5.88 5.88 0 014.46 1.86A6.19 6.19 0 0170 10a2 2 0 002 2h12v12H44V12zM108 122a2 2 0 01-2 2H22a2 2 0 01-2-2V14a2 2 0 012-2h18v14a2 2 0 002 2h44a2 2 0 002-2V12h17.77a2.38 2.38 0 011.63.61A1.85 1.85 0 01108 14z"}}),_c('path',{attrs:{"d":"M98 20h-4a2 2 0 000 4h2v88H32V24h2a2 2 0 000-4h-4a2 2 0 00-2 2v92a2 2 0 002 2h68a2 2 0 002-2V22a2 2 0 00-2-2z"}}),_c('path',{attrs:{"d":"M66 48h22a2 2 0 000-4H66a2 2 0 000 4zm0 12h16a2 2 0 000-4H66a2 2 0 000 4zm-20-.2a2 2 0 001.41.58h.09a2 2 0 001.5-.71L59.53 47a2 2 0 10-3.06-2.57l-9.19 11-5.87-5.86a2 2 0 00-2.82 2.83zM88 76H66a2 2 0 010-4h22a2 2 0 010 4zm-6 12H66a2 2 0 010-4h16a2 2 0 010 4zm-34.59.38A2 2 0 0146 87.8l-7.41-7.41a2 2 0 112.82-2.83l5.87 5.86 9.19-11A2 2 0 1159.53 75L49 87.67a2 2 0 01-1.45.71z"}})])
          )
        }
      }
    